export function parseLoanPatchError(e: unknown): string {
  if (e && typeof e === 'object' && 'data' in e) {
    const msg = (e as { data?: { error?: string } }).data?.error;
    if (msg) return String(msg);
  }
  return 'Save failed';
}

export function snapshotValue<T>(value: T): string {
  return JSON.stringify(value);
}
